import { render } from "./TabProdutosServicos.vue?vue&type=template&id=7fb24675&scoped=true"
import script from "./TabProdutosServicos.vue?vue&type=script&lang=js"
export * from "./TabProdutosServicos.vue?vue&type=script&lang=js"

import "./TabProdutosServicos.vue?vue&type=style&index=0&id=7fb24675&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb24675"]])

export default __exports__